import { useGetHttp } from "../../../http.hook";
import type { ILocationMinimal } from "../../../../../types/models/location.models.types";

interface IResponse {
  predictions: Array<ILocationMinimal>;
}

export function useAutocompleteCityCommonHttp() {
  return useGetHttp<IResponse>({
    path: "/common/utils/google-maps/autocomplete-city",
  });
}
